import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Colors, FontFamily, Input, Main, Models, NavBar, PrimaryButton } from "utils/imports.utils";
import { useSetState } from "utils/functions.utils";
import { ButtonSize, ButtonTypes } from "utils/interface.utils";
import "./forgot_password.screen.scss";

const ERROR_VISIBLE_MS = 5000;
const VALIDATION_PREFIX = "Error validating request body.";

const ForgotPasswordScreen = () => {
    const navigate = useNavigate();
    const [state, setState] = useSetState({
        email: "",
        error: "",
        activity: false,
    });

    // The message and the red outline clear themselves after a few seconds.
    useEffect(() => {
        if (!state.error) return;
        const timer = setTimeout(() => setState({ error: "" }), ERROR_VISIBLE_MS);
        return () => clearTimeout(timer);
    }, [state.error]);

    const handleSendOtp = async () => {
        setState({ activity: true, error: "" });
        try {
            await Models.auth.sendOtp({ email: state.email });
            navigate('/enter-otp', { state: { email: state.email } });
        } catch (error: any) {
            const message = typeof error === "string" ? error : "Failed to send OTP. Please try again.";
            setState({
                error: message.startsWith(VALIDATION_PREFIX) ? message.slice(VALIDATION_PREFIX.length).trim() : message,
            });
        } finally {
            setState({ activity: false });
        }
    };

    return (
        <Main backgroundColor={Colors.screenBackground} isRenderOnlyLogo={true} logoSize={{width: "200px", height: "83px"}}>
            <div className="forgot_password">
                <div className="forgot_password_container">
                    <div className="forgot_password_header">
                        <div className="forgot_password_header_title">Forgot password</div>
                        <div className="forgot_password_header_desc">Forgot your password? Let’s reset it</div>
                    </div>
                    <div className="forgot_password_form">
                        <div className={`forgot_password_form_input ${state.error ? "forgot_password_form_input_error" : ""}`}>
                            <Input
                                label="Enter your email id"
                                type="email"
                                placeholder="Enter your email id"
                                value={state.email}
                                onChange={(e) => setState({ email: e.target.value, error: "" })}
                            />
                        </div>
                        {state.error && (
                            <div className="input_field_error forgot_password_form_error" role="alert">
                                <span className="forgot_password_form_error_icon" aria-hidden="true">!</span>
                                <span>{state.error}</span>
                            </div>
                        )}
                    </div>
                    <div className="forgot_password_buttons">
                        <div className="forgot_password_buttons_send_otp">
                            <PrimaryButton
                                onClick={handleSendOtp}
                                fontFamily={FontFamily.medium}
                                lineHeight="28px"
                                text="Send OTP"
                                size={ButtonSize.LARGE}
                                type={ButtonTypes.PRIMARY_GRADIENT}
                                activity={state.activity}
                                disabled={state.activity || !state.email.trim()}
                            />
                        </div>
                        <div className="forgot_password_buttons_back">
                            <PrimaryButton
                                onClick={() => navigate('/login')}
                                text="Back"
                                fontFamily={FontFamily.semiBold}
                                type={ButtonTypes.TEXT_UNDERLINE}
                                size={ButtonSize.SMALL}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Main>
        
    )
}

export default ForgotPasswordScreen;